import { IJob } from "./interfaces";

const ACCESS_TOKEN_KEY = "categorizationAccessToken";
const JOBS_KEY = "allJobs";

export const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN_KEY);
export const setAccessToken = (token: string) =>
  localStorage.setItem(ACCESS_TOKEN_KEY, token);
export const removeAccessToken = () =>
  localStorage.removeItem(ACCESS_TOKEN_KEY);

export const getCachedJobs = () => localStorage.getItem(JOBS_KEY);
export const cacheJobs = (jobs: IJob[]) => {
  const strigifiedJobs = JSON.stringify(jobs);
  localStorage.setItem(JOBS_KEY, strigifiedJobs);
};
export const removeJobs = () => localStorage.removeItem(JOBS_KEY);

export const clearTokens = () => {
  removeAccessToken();
};

export function isTokenExpired(token: string): boolean {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
}
